import { RootState } from '@store';

export const selectServiceContract = (state: RootState) => {
  return state.serviceContract.serviceContract;
};

export const selectServiceContractLoading = (state: RootState) => {
  return state.serviceContract.serviceContractLoading;
};
